<template>
	<div class="ws-select"
		 @blur="open = false" 
		 :tabindex="tabindex"
	>
		<div class="selected" :data-value="selected[valueAttr]"
			 :class="{ open: open }"
			 @click="open = !open"
		>
				{{ selected[textAttr] }}
		</div>
        
		<div class="items" :class="{ hide: !open }">
			<div v-for="(option, i) in selectOptions"
				 :key="i"
				 @click="onClick(option)"
				 class="item"
				 :class="{ 'selected': option === selected, 'context': option.isContext, 'hidden': option.hidden }"
                 :data-value="option[valueAttr]"
			>
				{{ option[textAttr] }}
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		name: 'WSSelect',
		props: {
            modelValue: {
                required: false,
            },
			options: {
				type: Array,
				required: true,
			},
			default: {
				type: String,
				required: false,
				default: null,
			},
			tabindex: {
				type: Number,
				required: false,
				default: 0,
			},
            textAttr: {
                type: String,
                required: false,
                default: 'text',
            },
            valueAttr: {
                type: String,
                required: false,
                default: 'value',
            },
            direct: {
                type: Boolean,
                required: false,
                default: false,
            },
		},
        model: {
            prop: 'modelValue',
            event: 'change'
        },
		data() {
			return {
				open: false,
                userSelected: undefined,
			};
		},
        watch: {
            modelValue() {
                this.userSelected = null;
            },
        },
        created() {
            if (this.selected && this.selected.hasOwnProperty(this.valueAttr)) this.$emit('change', this.selected[this.valueAttr]);
        },
		computed: {
            selectOptions() {
                if (!this.direct) return this.options;
                let _selectOptions = [];
                for (let i = 0; i < this.options.length; i++) _selectOptions.push({text: this.options[i], value: this.options[i]});
                return _selectOptions;
            },
			selected: {
				get() {
                    if (this.userSelected) return this.userSelected;
                    else if (this.modelValue) return this.selectOptions.filter((v) => (v[this.valueAttr] === this.modelValue))[0];
					else if (this.default) return this.selectOptions.filter((v) => (v[this.valueAttr] === this.default))[0];
					else if (this.selectOptions.length > 0) return this.selectOptions[0];
					else return null;
				},
				set(option) {
                    this.userSelected = option;
                    if (option.hasOwnProperty(this.valueAttr)) {
                        this.$emit('change', option[this.valueAttr]);
                        this.$emit('input', option[this.valueAttr]);
                    }
                }
			}
		},
		methods: {
			onClick(option) {
				this.selected = option;
				this.open = false;
			}
		}
	};
</script>